module.exports = __webpack_public_path__ + "static/media/Air Asia_5_Calendar.27a445a8.jpg";